export default "__VITE_ASSET__BzjdUUlD__"